import { createSlice } from '@reduxjs/toolkit'

export const initSlice = createSlice({
  name: 'init',
  initialState: {
    value: null,
  },
  reducers: {
    initialize: (state) => {
      state.value = 1
    },
    resetInit: (state) => {
        state.value = null
    }
  },
})

export const { initialize, resetInit } = initSlice.actions
export default initSlice.reducer